import { HomeTemplate } from './home';

export default HomeTemplate;
